import { FaArrowLeft, FaDownload } from "react-icons/fa";
// import PromptBox from "./components/promptBox/PromptBox";
import avatar11 from "assets/images/users/avatar11.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
function ClientImageGenerator() {
  const navigate = useNavigate();
  const [generatedImage, setGeneratedImage] = useState([]);
  const backBtnHandler = () => {
    navigate(-1);
  };
  const onGenerateHandler = (prompt, files, settings) => {
    const newItems = files.map((file) => ({
      prompt,
      image: file,
      settings,
    }));

    setGeneratedImage((prev) => [...prev, ...newItems]);
  };
  return (
    //
    <div className="w-9/10 h-[82vh] border-2 shadow-xl border-gray-200 rounded-2xl">
      <div className="border-b-2 border-gray-200 h-[7vh] w-full flex items-center justify-between">
        <img src={avatar11} alt="" className="h-9 w-9 rounded-full mr-3" />
        <button
          type="button"
          onClick={backBtnHandler}
          className={`btn py-2.5 px-4 text-[#1b4747] rounded-md border-none  transition-all duration-300
                      hover:scale-110
                        `}
        >
          <FaArrowLeft className="text-[#1b4747] text-xl transition-all duration-300 group-hover:scale-110" />
        </button>
      </div>
      <div
        className="w-full h-[56vh] overflow-y-auto overflow-x-hidden flex flex-col items-center gap-3 p-3"
        id="mid"
      >
        {generatedImage.map((item, index) => (
          <div key={index} className="w-full items-center flex flex-col gap-2">
            {/* prompt */}
            <div className="flex w-full justify-start">
              <p className="text-sm text-gray-600 bg-gray-100 p-2 rounded-tl-xl rounded-tr-xl rounded-bl-xl">
                {item.prompt}
              </p>
            </div>
            {/* image */}
            <div className="relative w-80">
              <img
                src={item.image.url}
                className="w-80 border border-gray-400 rounded-md"
                alt={item.image.name}
              />

              {/* download */}
              <a
                href={item.image.url}
                download={item.image.name}
                className="absolute bottom-2 right-2 bg-black/70 text-white p-2 rounded-full hover:bg-black transition"
              >
                <FaDownload size={14} />
              </a>
            </div>
          </div>
        ))}
      </div>
      <div className="border-t-2 border-gray-200 w-full h-[10vh]">
        {/* <PromptBox onGenerate={onGenerateHandler} /> */}
      </div>
    </div>
  );
}
export default ClientImageGenerator;
